import { render, staticRenderFns } from "./ProcedimientosEvidencePagination.vue?vue&type=template&id=2bba4b8a&"
import script from "./ProcedimientosEvidencePagination.vue?vue&type=script&lang=js&"
export * from "./ProcedimientosEvidencePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports